<udex-tile
  *ngIf="entry.removed !== 'removed'"
>
  <dcp-checkout-licenses
    [cartEntry]="entry"
    [showPrice]="showPrice"
    [showEditAction]="showEditAction"
    [showRemoveAction]="showRemoveAction"
  ></dcp-checkout-licenses>
  <ng-content></ng-content>
  <div
    class="body--s udex-ps-20 udex-pb-12 udex-pt-8"
  >
    <dcp-terms-conditions
      *ngIf="!checkoutEntryValidationService.isEntryInvalid(entry)"
      tabindex="-1"
      [removalStatus]="entry.removed" 
      [entry]="entry"
      [entries]="entries"
    >
    </dcp-terms-conditions>
  </div>
</udex-tile>
<dcp-remove-product-success-message
  *ngIf="entry.removed === 'removed' && entryCount > 1"
  [orderEntry]="entry">
</dcp-remove-product-success-message>
